'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-memoize.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/memoize/dist/emotion-memoize.cjs.js
// module id = 843
// module chunks = 0